// extracted by mini-css-extract-plugin
export default {"Tooltip":"tooltip_Tooltip__hPuuP","tooltipContent":"tooltip_tooltipContent__OAuOu","open":"tooltip_open__kItTZ","hover":"tooltip_hover__dE6zp"};